export default function (action, error) {
    // TODO: add error catch log here like sentry or similar or existing one
    console.log('Error from action = ', action, ' error message = ', error);
}